module.exports = __webpack_public_path__ + "media/images/upload-example-3-d5e18090e493db231dec82d6b2a4dd73.png";